export function isNonEmpty<T>(input: T[]): input is [T, ...T[]] {
  return input.length > 0;
}

export function getNonEmpty<T>(input: T[]): [T, ...T[]] {
  if (!isNonEmpty(input)) {
    throw new Error('Non empty array is empty');
  }
  return input;
}
